/**
 * CorporateFooterStrip — quiet legitimacy line rendered at the absolute
 * bottom of every page (below any page-specific footer). Owen Feb 2026:
 * follows the SaaS/e-commerce convention (Shopify, Stripe, Notion) of
 * disclosing the incorporating entity + registration status in muted
 * type at the site-wide footer, so trust is present at every decision
 * moment rather than only on the marketing landing.
 *
 * Owen deliberately kept the specific town (Dundurn, SK) out of the
 * public strip — the province is public record via the ISC filing and
 * is enough context for anyone verifying legitimacy without exposing
 * a small-town address on every page.
 *
 * `theme-fixed` — the strip must stay charcoal/gold regardless of the
 * user's active theme so it reads as institutional footer chrome, not
 * page content.
 */
const CorporateFooterStrip = () => {
  return (
    <div
      className="theme-fixed w-full bg-[#1C1917]"
      role="contentinfo"
      aria-label="Corporate registration"
      data-testid="corporate-footer-strip"
    >
      <p
        className="text-center text-[10px] sm:text-[11px] tracking-[0.08em] text-[#8A817C] px-16 sm:px-4 py-2.5 leading-relaxed"
        style={{ fontFamily: 'Work Sans, sans-serif' }}
      >
        A federally-incorporated Canadian company
        <span className="mx-1.5 text-[#57534E]" aria-hidden="true">·</span>
        Est. 6 May 2026
        <span className="mx-1.5 text-[#57534E]" aria-hidden="true">·</span>
        Extra-provincially registered in Saskatchewan
      </p>
    </div>
  );
};

export default CorporateFooterStrip;
